export default "/_nuxt/c5b36d6af310ff240ed179385d42751c.svg";